query UsersList(
  $page: Int
  $rowsPerPage: Int
  $filter: UsersFilterInput
) {
  users(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      email
      firstName
      lastName
      displayName
      avatar {
        id
        url(format: SMALL)
      }
      agreeToMarketingNewsletters
      language
      country
      timeZone
      createdAt
      updatedAt
    }
  }
}
